import { createSlice } from "@reduxjs/toolkit";
import { createDisputeItem, fetchDisputesItems } from "./DisputesThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const disputesSlice = createSlice({
  name: "disputes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDisputesItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDisputesItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchDisputesItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createDisputeItem.pending, (state) => {
        state.createStatus = "loading";
      })
      .addCase(createDisputeItem.fulfilled, (state, action) => {
        state.createStatus = "succeeded";
        state.items.push(action.payload); // if you want to instantly add
      })
      .addCase(createDisputeItem.rejected, (state, action) => {
        state.createStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default disputesSlice.reducer;
